import Vue from 'vue'
import Vuex from 'vuex'

import mineStore from './mineStore'
//wyk持久化 one
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    mineStore
  },
  plugins: [createPersistedState()]  //wyk持久化 two
})



// WEBPACK FOOTER //
// ./src/store/index.js